const LOCATION = "tenant"

export default {

  WriteCredential:function(data){
    localStorage.setItem(LOCATION, JSON.stringify(data))
  },

  GetCredential:function(){
    var Credential = localStorage.getItem(LOCATION)

    if(Credential === null || Credential === undefined || Credential === ""){
      return{
        login                 :null,
        dashboard             :null,
        report                :null,
        coverage_city         :null,
        in_active_site_status :null,
      }
    }
    return JSON.parse(Credential)
  },
}



// WEBPACK FOOTER //
// ./src/App/store/tenant/auth.js